export const isEmptyObject = (o: Record<string, unknown>) => {
  return typeof o === 'object' && Object.keys(o).length === 0
}
